import CollectionCard from './CollectionCard';

export default CollectionCard;
